import { useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useCallback, useEffect, useState } from 'react';

import {
  SendDispensingPreparedNotificationDocument,
  SkipEncounterDocument,
} from '~/graphql/generated/graphql';
import { notificationConfirmModalState } from '~/state/partials/patient_profile_drawer/atoms';

export const useSendMessage = () => {
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { isOpen, appointmentId } = useAtomValue(notificationConfirmModalState);
  const resetNotificationConfirmModalState = useResetAtom(notificationConfirmModalState);

  const [skipEncounter] = useMutation(SkipEncounterDocument);
  const [sendDispensingPreparedNotification] = useMutation(
    SendDispensingPreparedNotificationDocument,
  );

  const handleSend = useCallback(async () => {
    if (!appointmentId) return;

    setIsSending(true);

    try {
      await sendDispensingPreparedNotification({
        variables: {
          input: {
            appointmentId,
          },
        },
      });

      // 指導待ち -> 未会計に変更
      await skipEncounter({
        variables: {
          input: {
            appointmentId,
          },
        },
      });

      resetNotificationConfirmModalState();
    } catch (_error) {
      setError(_error?.message || 'エラーが発生しました');
    } finally {
      setIsSending(false);
    }
  }, [
    appointmentId,
    sendDispensingPreparedNotification,
    skipEncounter,
    resetNotificationConfirmModalState,
  ]);

  useEffect(() => {
    if (isOpen) {
      setError(null);
    }
  }, [isOpen]);

  return { sending: isSending, error, handleSend };
};
